module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1233.34f85a5f.png";